<template>
  <div class="gameList" @click="enterDetails($event,game)">
    <img v-lazy="game.iconUrl" :key="game.iconUrl" alt />
    <div class="gameInfo">
      <h2 class="gameTitle">{{game.displayName}}</h2>
      <p>
        <span>{{game.appDownCount|handleDownload}}下载量</span>
        <span>{{game.fileSize|handlePkgSize}}</span>
      </p>
      <p>{{game.briefIntro}}</p>
    </div>
    <div class="open">
      <button v-if="isdown">{{game.btntext}}</button>
      <button v-else>打开</button>
    </div>
  </div>
</template>
<script>
import config from "@/../config";
export default {
  props: ["game", "isdown","from"],
  filters: {
    handleDownload: function(value) {
      if (value >= 10000) {
        return Math.ceil(value / 10000) + "万+";
      }
      return value + "次";
    },
    handlePkgSize: function(value) {
      let a = Math.floor((value / 1048576) * 100) / 100;
      if (a > 1024) {
        return Math.floor((a / 1024) * 100) / 100 + "G";
      }
      return a + "M";
    }
  },
  mounted() {},
  watch: {
    $route(to, from) {
      this.$router.go(0);
    }
  },
  methods: {
    enterDetails(event, game) {
      if (
        event.target.tagName === "BUTTON" &&
        event.target.innerHTML !== "打开"
      ) {
        this.$parent.changebtn(game);
      } else {
        if(this.from){
          this.$parent.jumpDetail(game)
        }else{
          const p = location.href.split("?");
          window.location.href = `${config.SERVER_TEMP}/gameserv/GameDetail/detail.html?gameId=${game.id}&${p[1]}`;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.gameList {
  display: flex;
  height: 0.96rem;
  padding: 0.16rem 0;
  position: relative;
  > img {
    width: 0.63rem;
    height: 0.63rem;
    border-radius: 0.13rem;
    flex: 1;
  }
  .gameInfo {
    flex: 3;
    margin-left: 0.13rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    h2 {
      line-height: 0.22rem;
      color: #333;
      font-size: 0.16rem;
      font-weight: 650;
      margin-top: 0.03rem;
      margin-bottom: 0.03rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 8em;
    }
    p {
      font-size: .14rem;
      line-height: 0.17rem;
      width: 1.8rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span:first-child {
        margin-right: 0.06rem;
      }
    }
  }
  .open {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    > button {
      width: 0.75rem;
      height: 0.29rem;
      background: #f4f4f4;
      border: 0;
      border-radius: 0.15rem;
      color: #ff5000;
      font-weight: 650;
    }
  }
}
.gameList::after {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: #f0f0f0;
    -webkit-transform: scaleY(0.5);
}
</style>
